module.exports = __webpack_public_path__ + "img/240.2d5195d4.png";